function initLPSlider({ id = '', isDots = false, isArrow = false }) {
  const elemLPSlider = document.getElementById(id);

  const sliderConfig = {
    slidesPerView: 'auto',
    speed: 1000,
    spaceBetween: 16,
    centerInsufficientSlides: true,
  }

  if (isDots) {
    sliderConfig.pagination = {
      el: '.swiper-pagination',
      clickable: true
    }
  }

  if (isArrow) {
    sliderConfig.navigation = {
      nextEl: '.navigation .swiper-button-next-custom',
      prevEl: '.navigation .swiper-button-prev-custom',
    };
  }

  new Swiper(elemLPSlider.querySelector('.swiper'), sliderConfig);
}

function initLPSliderFeedbacks({ id = '', isDots = false, isArrow = false }) {
  const elemLPSlider = document.getElementById(id);

  const sliderConfig = {
    slidesPerView: 'auto',
    speed: 1000,
    spaceBetween: 122,
    centerInsufficientSlides: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.navigation .swiper-button-next-custom',
      prevEl: '.navigation .swiper-button-prev-custom',
    }
  }

  new Swiper(elemLPSlider.querySelector('.swiper'), sliderConfig);
}